import { render } from "./PayBets.vue?vue&type=template&id=072d5351"
import script from "./PayBets.vue?vue&type=script&lang=js"
export * from "./PayBets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__